import {
  List,
  ListItem,
  ListItemText,
  ListItemButton,
  Box,
  Typography,
  Container,
} from "@mui/material";
import toast from "react-hot-toast";
import { NavLink } from "react-router-dom";

// ── Aqua palette ──────────────────────────────────────────────────────────────
const AQ = {
  bg:        "#050f12",
  border:    "rgba(0,220,200,0.15)",
  primary:   "#00A0FF",
  primaryDim:"rgba(0,229,200,0.12)",
  text:      "#7FCEFF",
  glow:      "0 0 12px rgba(0,229,200,0.35)",
};

export default function Footer() {

  return (
    <Box
      component="footer"
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        background: "#0f0f1a",
        borderTop: `1px solid ${AQ.border}`,
        zIndex: 1000,
      }}
    >
      <Container sx={{ p: "0 !important" }}>
        <List
          className="footer_main"
          sx={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          {/* Home */}
          <ListItem disablePadding>
            <ListItemButton
              component={NavLink}
              to="/Dashboard"
              sx={navStyle}
            >
              <Box>
                <i className="ri-home-4-line"></i>
              </Box>
              <ListItemText
                primary={<Typography variant="caption">Home</Typography>}
              />
            </ListItemButton>
          </ListItem>

          {/* Markets */}
          <ListItem disablePadding>
            <ListItemButton
              component={NavLink}
              to="/markets"
              sx={navStyle}
            >
              <Box>
                <i className="ri-bar-chart-box-ai-line"></i>
              </Box>
              <ListItemText
                primary={<Typography variant="caption">Markets</Typography>}
              />
            </ListItemButton>
          </ListItem>

          {/* Trade */}
          <ListItem disablePadding>
            <ListItemButton
              component={NavLink}
              to="/binary/BTCUSDT"
              sx={navStyle}
            >
              <Box className="trade_icon">
                <i className="ri-pie-chart-line"></i>
              </Box>
              <ListItemText
                primary={<Typography variant="caption">Trade</Typography>}
              />
            </ListItemButton>
          </ListItem>

          {/* Assets */}
          <ListItem disablePadding>
            <ListItemButton
              component={NavLink}
              to="/MyTrades"
              sx={navStyle}
            >
              <Box>
                <i className="ri-wallet-3-line"></i>
              </Box>
              <ListItemText
                primary={<Typography variant="caption">My Trades</Typography>}
              />
            </ListItemButton>
          </ListItem>

          <ListItem disablePadding>
            <ListItemButton
              component={NavLink}
              to="/Profile"
              sx={navStyle}
            >
              <Box>
                <i className="ri-team-line"></i>
              </Box>
              <ListItemText
                primary={<Typography variant="caption">Profile</Typography>}
              />
            </ListItemButton>
          </ListItem>
        </List>
      </Container>
    </Box>
  );
}

// ── Regular tab style ────────────────────────────────────────────────────────
const navStyle = {
  flexDirection: "column",
  alignItems: "center",
  textAlign: "center",
  color: AQ.text,
  minWidth: "auto",
  py: 1,
  transition: "all 0.2s",

  "& i": {
    fontSize: 22,
    marginBottom: "3px",
    color: AQ.text,
    transition: "color 0.2s, text-shadow 0.2s",
    display: "block",
  },

  "&:hover": {
    color: AQ.primary,
    "& i": { color: AQ.primary },
  },

  "&.active": {
    color: AQ.primary,
    backgroundColor: "transparent",
    "& i": {
      color: AQ.primary,
      textShadow: "0 0 10px rgba(0,229,200,0.7)",
    },
  },

  "&.Mui-selected": { backgroundColor: "transparent" },
};